/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import { useEffect, useState } from "react";
import { ClockCountdownIcon, SparkleIcon } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const TrialBadge = ({ sessionId, compact = false }) => {
  const [trial, setTrial] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    api.get(`/trial/${sessionId}`).then((r) => setTrial(r.data)).catch(() => {});
  }, [sessionId]);

  if (!trial) return null;
  const { days_left, expired } = trial;

  if (expired) {
    return (
      <div
        className={`flex items-center gap-1.5 ${compact ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs"} rounded-full border border-[#FF007F]/40 bg-[#FF007F]/10 text-[#FF007F]`}
        data-testid="trial-badge-expired"
      >
        <SparkleIcon size={compact ? 10 : 12} weight="fill" /> Trial ended — upgrade to Pro
      </div>
    );
  }

  return (
    <div
      className={`flex items-center gap-1.5 ${compact ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs"} rounded-full border border-[#39FF14]/30 bg-[#39FF14]/5 text-[#39FF14]`}
      data-testid="trial-badge-active"
    >
      <ClockCountdownIcon size={compact ? 10 : 12} weight="bold" />
      <span className="font-semibold">{days_left}d</span>
      <span className="text-white/60">free trial · all platforms</span>
    </div>
  );
};

export default TrialBadge;
